export const types = {
  SET_ID: 'common/helpMode/SET_ID',
};

export const setId = (id) => ({
  type: types.SET_ID,
  payload: { id },
});
